import * as _4 from 'lodash4';
export class ParseDictionaryServant {
  static transformKeys(configObject: Record<string, any>): Record<string, any> {
    const transformKeysToSentence: Record<string, any> = _4.mapKeys(configObject, (o: string, k: string) =>
      _4.capitalize(_4.words(k).join(' '))
    );
    const sortByKeys = _4.sortBy(_4.toPairs<Record<string, any>>(transformKeysToSentence), (item: string[]) => item[0]);
    return _4.fromPairs(sortByKeys as Array<[string, any]>);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-settings/src/about/servants/parse_dictionary_servant.ts